<script setup>
import moment from "moment";
moment.locale("id");
</script>

<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="px-3 pb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Verifikasi Data
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="container p-4">
              <!-- form di sini -->
              <form action="#" @submit.prevent="preventSubmit">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <table style="font-family: 'Inter-Regular'">
                      <tbody>
                      <tr class="border border-2 rounded-top rounded-3">
                        <td
                          colspan="2"
                          class="fs-6 p-2 text-light"
                          style="background-color: #dd3737"
                        >
                          Informasi Umum
                        </td>
                      </tr>
                      <tr class="border border-2">
                        <th
                          class="p-2"
                          style="width: 30%; background-color: #ffe5e5"
                        >
                          Keterangan
                        </th>
                        <th
                          class="p-2"
                          style="width: 70%; background-color: #ffe5e5"
                        >
                          Data
                        </th>
                      </tr>
                      <tr class="border border-2">
                        <td class="text-muted p-2">Nama Perusahaan Jasa</td>
                        <td class="p-2">
                          {{ capitalized(kontraktor?.namaKontraktor) }}
                        </td>
                      </tr>
                      <tr class="border border-2">
                        <td class="text-muted p-2">Kategori Perusahaan</td>
                        <td class="p-2">
                          {{ kontraktor?.wilayah }}
                        </td>
                      </tr>
                      <tr class="border border-2">
                        <td class="text-muted p-2">
                          Klasifikasi Perusahaan Jasa
                        </td>
                        <td class="p-2">{{ kontraktor?.jenis }}</td>
                      </tr>
                      <tr class="border border-2">
                        <td class="text-muted p-2">
                          Kualifikasi Perusahaan Jasa
                        </td>
                        <td class="p-2">
                          {{ kualifikasiUsaha(kontraktor?.kualifikasiUsaha) }}
                        </td>
                      </tr>
                      <tr class="border border-2">
                        <td class="text-muted p-2">File Dokumen NIB</td>
                        <td
                          class="p-2"
                          :class="{ pointer: kontraktor?.fileNib != null }"
                          @click="
                            kontraktor?.fileNib != null
                              ? viewFile(kontraktor?.fileNib)
                              : ''
                          "
                        >
                          <font-awesome-icon icon="fa-solid fa-eye" />{{
                            kontraktor?.fileNib != null
                              ? kontraktor?.fileNib
                              : "-"
                          }}
                        </td>
                      </tr>
                      <tr class="border border-2">
                        <td class="text-muted p-2">File Dokumen IUJP</td>
                        <td
                          class="p-2"
                          :class="{ pointer: kontraktor?.fileIujp != null }"
                          @click="
                            kontraktor?.fileIujp != null
                              ? viewFile(kontraktor?.fileIujp)
                              : ''
                          "
                        >
                          <font-awesome-icon icon="fa-solid fa-eye" />{{
                            kontraktor?.fileIujp != null
                              ? kontraktor?.fileIujp
                              : "-"
                          }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-12">
                    <table
                      class=""
                      style="width: 100%; font-family: 'Inter-Regular'"
                    >
                      <tbody>
                      <tr class="border border-2 rounded-top rounded-3">
                        <td
                          colspan="7"
                          class="fs-6 p-2 text-light"
                          style="background-color: #dd3737"
                        >
                          KBLI
                        </td>
                      </tr>
                      <tr class="border border-2">
                        <th
                          class="p-2"
                          style="width: 6%; background-color: #ffe5e5"
                        >
                          Kode KBLI
                        </th>
                        <th
                          class="p-2"
                          style="width: 19%; background-color: #ffe5e5"
                        >
                          Judul
                        </th>
                        <th
                          class="p-2"
                          style="width: 14%; background-color: #ffe5e5"
                        >
                          Tingkat Resiko
                        </th>
                        <th
                          class="p-2"
                          style="width: 10%; background-color: #ffe5e5"
                        >
                          Sertifikat
                        </th>
                        <th
                          class="p-2"
                          style="width: 10%; background-color: #ffe5e5"
                        >
                          Izin
                        </th>
                        <th
                          class="p-2 text-center"
                          style="width: 8%; background-color: #ffe5e5"
                        >
                          Is Verified
                        </th>
                        <th
                          class="p-2"
                          style="width: 23%; background-color: #ffe5e5"
                        >
                          Catatan
                        </th>
                      </tr>
                      <template v-if="kblis?.length > 0">
                        <tr
                          class="border border-2"
                          v-for="(row, index) in kblis"
                          :key="index"
                        >
                          <td
                            class="p-2"
                            :class="{
                              'text-danger fw-bold': !row.isVerified,
                            }"
                          >
                            {{ row.noKbli }}
                          </td>
                          <td
                            class="p-2"
                            :class="{
                              'text-danger fw-bold': !row.isVerified,
                            }"
                          >
                            {{ row.deskripsi }}
                          </td>
                          <td
                            class="p-2"
                            :class="{
                              'text-danger fw-bold': !row.isVerified,
                            }"
                          >
                            {{ tingkatResiko(row.tingkatResiko) }}
                          </td>
                          <td
                            class="p-2"
                            :class="{
                              'text-danger fw-bold': !row.isVerified,
                            }"
                          >
                            <a
                              v-if="
                                row.fileSertifikat != null &&
                                row.tingkatResiko != 4
                              "
                              @click="viewFile(row.fileSertifikat)"
                              class="text-decoration-none pointer"
                              :class="{
                                'text-danger fw-bold': !row.isVerified,
                                'text-dark': row.isVerified,
                              }"
                            >
                              Terverifikasi
                              <font-awesome-icon
                                size="xl"
                                icon="fa-solid fa-file-arrow-down"
                                class="text-danger"
                              />
                            </a>
                            <a v-else>-</a>
                          </td>
                          <td
                            class="p-2"
                            :class="{
                              'text-danger fw-bold': !row.isVerified,
                            }"
                          >
                            <a
                              v-if="
                                row.fileIzin != null && row.tingkatResiko == 4
                              "
                              @click="viewFile(row.fileIzin)"
                              class="text-decoration-none pointer"
                              :class="{
                                'text-danger fw-bold': !row.isVerified,
                                'text-dark': row.isVerified,
                              }"
                            >
                              Terverifikasi
                              <font-awesome-icon
                                size="xl"
                                icon="fa-solid fa-file-arrow-down"
                                class="text-danger"
                              />
                            </a>
                            <a v-else>-</a>
                          </td>
                          <td>
                            <div
                              class="d-flex justify-content-center align-items-center"
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="row.isVerified"
                                style="
                                  border-radius: 10px;
                                  border-color: black;
                                  margin: 0;
                                "
                              />
                            </div>
                          </td>
                          <td class="py-2" style="padding-right: 0.5rem">
                            <textarea
                              class="form-control"
                              v-model="row.notes"
                              :id="`catatan-kbli-${row.id}`"
                            ></textarea>
                            <div
                              :id="`text-warning-kbli-${row.id}`"
                              class="invalid-feedback"
                            ></div>
                          </td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr class="border border-2">
                          <td colspan="7" class="text-center fst-italic p-2">
                            Belum ada data KBLI
                          </td>
                        </tr>
                      </template>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-12">
                    <table class="" style="font-family: 'Inter-Regular'">
                      <tbody>
                      <tr class="border border-2 rounded-top rounded-3">
                        <td
                          colspan="4"
                          class="fs-6 p-2 text-light"
                          style="background-color: #dd3737"
                        >
                          Bidang IUJP
                        </td>
                      </tr>
                      <tr class="border border-2">
                        <th
                          class="p-2"
                          style="width: 20%; background-color: #ffe5e5"
                        >
                          Bidang
                        </th>
                        <th
                          class="p-2"
                          style="width: 46%; background-color: #ffe5e5"
                        >
                          Sub Bidang
                        </th>
                        <th
                          class="p-2 text-center"
                          style="width: 9%; background-color: #ffe5e5"
                        >
                          is Verified
                        </th>
                        <th
                          class="p-2"
                          style="width: 25%; background-color: #ffe5e5"
                        >
                          Catatan
                        </th>
                      </tr>
                      <template v-if="bidangs?.length > 0">
                        <tr
                          class="border border-2"
                          v-for="(row, index) in bidangs"
                          :key="index"
                        >
                          <td
                            class="p-2"
                            :class="{
                              'text-danger fw-bold': !row.is_verified,
                            }"
                          >
                            {{ row.NMBIDANG }}
                          </td>
                          <td
                            class="p-2"
                            :class="{
                              'text-danger fw-bold': !row.is_verified,
                            }"
                          >
                            {{ row.SUBBIDANG }}
                          </td>
                          <td>
                            <div
                              class="d-flex justify-content-center align-items-center"
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="bidangs[index].is_verified"
                                style="border-radius: 10px; border-color: black"
                              />
                            </div>
                          </td>
                          <td class="py-2" style="padding-right: 0.5rem">
                            <textarea
                              class="form-control"
                              v-model="bidangs[index].notes"
                              :id="`catatan-bidang-${index}`"
                            ></textarea>
                            <div
                              :id="`text-warning-bidang-${index}`"
                              class="invalid-feedback"
                            ></div>
                          </td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr class="border border-2">
                          <td colspan="4" class="text-center fst-italic p-2">
                            Belum ada data Bidang IUJP
                          </td>
                        </tr>
                      </template>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 d-flex justify-content-end">
                    <button
                      :disabled="!btnSetujui"
                      type="button"
                      class="btn btn-danger w-25 me-2"
                      @click="validasiIsVerified"
                    >
                      Tolak
                    </button>
                    <button
                      :disabled="btnSetujui"
                      type="button"
                      class="btn btn-success w-25"
                      @click="approveChanges"
                    >
                      Setujui
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>

  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
  <div
    class="modal fade"
    id="modalRejectChanges"
    tabindex="-1"
    aria-labelledby="modalRejectChangesLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Tolak Penerbitan Data Kontraktor</h5>
          <div class="d-flex justify-content-end">
            <button
              ref="closeModalRejectChanges"
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <div class="row">
            <div class="col-md-12">
              <div class="mb-1">
                <label for="file" class="form-label fs-8 fw-bold">Alasan</label>
              </div>
              <textarea
                class="form-control fs-8"
                id="exampleFormControlTextarea1"
                rows="7"
                v-model="reason"
                placeholder="Masukkan alasan mengapa perubahan data ditolak"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer border border-0 mt-1">
          <button
            :disabled="reason?.trim() == '' || reason == null"
            class="btn btn_cari w-100 fs-8 fw-bold"
            @click="rejectChanges()"
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalDataMixin from "../../GlobalDataMixin";
// import SidebarComponent from "@/components/SideBar.vue";
import axios from "axios";
import {
  API_BASE_URL,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_SET_VERIFIKASI_DATA,
  CMS_VIEW_DOCUMENT,
} from "@/constants";
import {
  capitalized,
  kualifikasiUsaha,
  tingkatResiko,
} from "@/utilities/helpers";
import Swal from "sweetalert2";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const url = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_view_document = API_BASE_URL + CMS_VIEW_DOCUMENT;
const url_set_changes = API_BASE_URL + CMS_SET_VERIFIKASI_DATA;
export default {
  mixins: [GlobalDataMixin],
  name: "verifikasiDataKontraktorPenerbitanPage",
  components: { DefaultLayout },
  data() {
    return {
      isLoading: false,
      kontraktor: null,
      kblis: [],
      bidangs: [],
      reason: null,
      btnSetujui: true,
      checkKbliSetujui: false,
      checkBidangSetujui: false,
    };
  },
  mounted() {
    this.fetchData(this.$route.params.kontraktorId);
  },
  watch: {
    kblis: {
      handler(newVal) {
        this.handlerButton(newVal, "kbli");
      },
      deep: true,
    },
    bidangs: {
      handler(newVal) {
        this.handlerButton(newVal, "bidang");
      },
      deep: true,
    },
  },
  methods: {
    capitalized,
    kualifikasiUsaha,
    tingkatResiko,
    preventSubmit() {
      console.log("prevent submit");
    },
    fetchData(id) {
      axios
        .get(url + id, { headers: { accept: "application/json" } })
        .then((response) => {
          this.kontraktor = response.data.detailKontraktor;
          this.kblis = response.data.dataKbli;
          const arr_bid = [];
          for (let key in this.kontraktor.bidang) {
            let subi = this.kontraktor.bidang[key];

            for (let xx in subi) {
              if (
                key != "" &&
                key != null &&
                subi[xx] != "" &&
                subi[xx] != null
              ) {
                arr_bid.push({
                  NMBIDANG: key,
                  SUBBIDANG: subi[xx].split("-")[0],
                  is_verified: JSON.parse(subi[xx].split("-")[1]),
                  notes:
                    subi[xx].split("-")[2] === "null"
                      ? null
                      : subi[xx].split("-")[2],
                });
              }
            }
          }
          this.bidangs = arr_bid;
          let checkKbli = this.kblis.every((item) => item.isVerified === true);
          let checkBidang = this.bidangs.every(
            (item) => item.is_verified === true
          );

          if (
            this.kblis.length > 0 &&
            checkKbli &&
            this.bidangs.length > 0 &&
            checkBidang
          ) {
            this.btnSetujui = !this.btnSetujui;
          } else if (
            this.kblis.length > 0 &&
            checkKbli &&
            this.bidangs.length === 0 &&
            this.kontraktor.jenis.toLocaleLowerCase() === "non inti"
          ) {
            this.btnSetujui = !this.btnSetujui;
          }
        });
    },
    viewFile(fileName) {
      window.open(url_view_document + fileName, "_blank");
    },
    handlerButton(newVal, type) {
      if (type === "kbli") {
        this.checkKbliSetujui = newVal.every(
          (item) => item.isVerified !== null && item.isVerified !== false
        );
      } else if (type === "bidang") {
        this.checkBidangSetujui = newVal.every(
          (item) => item.is_verified !== null && item.is_verified !== false
        );
      }

      if (this.bidangs.length > 0 && this.kblis.length > 0) {
        this.btnSetujui = !(this.checkKbliSetujui && this.checkBidangSetujui);
      } else if (
        this.bidangs.length == 0 &&
        this.kblis.length > 0 &&
        this.kontraktor.jenis.toLocaleLowerCase() === "non inti"
      ) {
        this.btnSetujui = !this.checkKbliSetujui;
      }
    },
    approveChanges() {
      Swal.fire({
        title: "Konfirmasi Setuju Perubahan Data Kontraktor",
        text: "Apakah anda yakin untuk menyetujui perubahan data kontraktor ?",
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.setChangesKontraktor(true);
        }
      });
    },
    rejectChanges() {
      this.$refs.closeModalRejectChanges.click();
      this.setChangesKontraktor(false);
    },
    setChangesKontraktor(action) {
      console.log(url_set_changes);
      const kblis = [];
      this.isLoading = true;
      this.kblis.forEach((item) => {
        kblis.push({
          id: item.id,
          isVerified: item.isVerified,
          notes: item.notes,
        });
      });
      let bodyJson = {
        id: this.$route.params.kontraktorId,
        idSio: this.$route.params.id,
        bidangUsahaGems: JSON.stringify(this.bidangs),
        kbli: kblis,
        action: action,
        notes: action ? null : this.reason,
      };
      axios
        .post(url_set_changes, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          if (response.status == 200) {
            Swal.fire({
              title: action
                ? "Setujui Data Kontraktor"
                : "Tolak Data Kontraktor",
              text: action
                ? "Data Kontraktor berhasil disetujui!"
                : "Penerbitan CoC data kontraktor berhasil ditolak!",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              showClass: {
                popup: "animate__animated animate__fadeInDown",
              },
              hideClass: {
                popup: "animate__animated animate__fadeOutUp",
              },
            }).then(() => {
              this.isLoading = false;
              this.$router.back();
            });
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan!",
          });
        });
    },
    validasiIsVerified() {
      let status = true;
      this.kblis?.forEach((item) => {
        if (!item.isVerified && (!item.notes || item.notes?.trim() == "")) {
          document.querySelector(`#text-warning-kbli-${item.id}`).textContent =
            "Catatan wajib diisi";
          document
            .querySelector(`#catatan-kbli-${item.id}`)
            .classList.add("is-invalid");
          status = status && false;
        } else {
          document.querySelector(`#text-warning-kbli-${item.id}`).textContent =
            "";
          document
            .querySelector(`#catatan-kbli-${item.id}`)
            .classList.remove("is-invalid");
          status = status && true;
        }
      });

      this.bidangs?.forEach((item, index) => {
        if (!item.is_verified && (!item.notes || item.notes?.trim() == "")) {
          document.querySelector(`#text-warning-bidang-${index}`).textContent =
            "Catatan wajib diisi";
          document
            .querySelector(`#catatan-bidang-${index}`)
            .classList.add("is-invalid");
          status = status && false;
        } else {
          document.querySelector(`#text-warning-bidang-${index}`).textContent =
            "";
          document
            .querySelector(`#catatan-bidang-${index}`)
            .classList.remove("is-invalid");
          status = status && true;
        }
      });
      if (status) {
        const newElement = document.createElement("button");
        newElement.setAttribute("data-bs-toggle", "modal");
        newElement.setAttribute("data-bs-target", "#modalRejectChanges");
        document.body.appendChild(newElement);
        newElement.click();
        setTimeout(() => {
          document.body.removeChild(newElement);
        }, 50);
      }
    },
  },
};
</script>

<style scoped>
table {
  table-layout: auto;
}
</style>
